import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { githubProjects } from '../../mocks/projects';
import IntuneVaultCard from './components/IntuneVaultCard';
import BitLockerCard from './components/BitLockerCard';

const ProjectsPage = () => {
  const intuneVaultProject = githubProjects.find(p => p.name === 'IntuneVault');
  const bitlockerProject = githubProjects.find(p => p.name === 'BitLocker Recovery Key Manager');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)'
          }} />
        </div>
        <div className="relative max-w-6xl mx-auto px-8">
          <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-5xl font-bold text-white mb-6">Projelerim</h1>
            <p className="text-xl text-white/90 leading-relaxed max-w-3xl">
              Açık kaynaklı güvenlik araçları, otomasyon scriptleri ve topluluk odaklı projeler. 
              Microsoft Security ekosistemi için geliştirdiğim çözümler.
            </p>
          </motion.div>
        </div>
      </section>

      {/* IntuneVault - Flagship */}
      {intuneVaultProject && (
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-8">
            <IntuneVaultCard project={intuneVaultProject} index={0} />
          </div>
        </section>
      )}

      {/* BitLocker Recovery - Entra ID */}
      {bitlockerProject && (
        <section className="py-20 bg-gray-50">
          <div className="max-w-6xl mx-auto px-8">
            <div className="flex items-center space-x-3 mb-8">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent to-gray-300"></div>
              <span className="px-4 py-1.5 bg-violet-100 text-violet-700 text-xs font-bold rounded-full tracking-wider">
                ENTRA ID PROJECT
              </span>
              <div className="h-px flex-1 bg-gradient-to-l from-transparent to-gray-300"></div>
            </div>
            <BitLockerCard project={bitlockerProject} index={1} />
          </div>
        </section>
      )}

      <Footer />
    </div>
  );
};

export default ProjectsPage;
